import { SearchBar } from "antd-mobile";
import type { SearchBarProps, SearchBarRef } from "antd-mobile";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { ReactNode, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

interface IProps extends SearchBarProps {
  leftIcon: ReactNode;
  onChange?: (value: string) => Promise<void>;
  onSearchClick?: () => void;
  headingText?: string;
}

export const GlobalSearchBar: FC<IProps> = ({
  leftIcon,
  onChange,
  onSearchClick,
  headingText,
}) => {
  const location = useLocation();
  const searchRef = useRef<SearchBarRef>(null);

  useEffect(() => {
    if (location.pathname === "/search") searchRef.current?.focus();
  });

  return (
    <div className={styles.container}>
      {leftIcon && <div className={styles.leftIcon}>{leftIcon}</div>}
      <SearchBar
        onFocus={onSearchClick}
        ref={searchRef}
        placeholder="Search by Patient Name or Room"
        data-test-id="global-search"
        clearable
        className={classNames(styles.globalSearchBar, {
          [styles.searchBarWithoutIcon]: !leftIcon,
        })}
        onChange={onChange}
      />
      {headingText && (
        <h5 className={styles.heading} id="main-heading">
          {headingText}
        </h5>
      )}
    </div>
  );
};
